import request from '@/utils/request';
//附加险
export function attachList(data) {
  return request.post('admin/v2/insurance-attach/list', data);
}
export function editAttach(data) {
  return request.post('admin/v2/insurance-attach/edit', data);
}
export function addAttach(data) {
  return request.post('admin/v2/insurance-attach/store', data);
}
// export function attachCopy(data) {
//   return request.post('admin/insurance-attach/copy', data);
// }
// export function delAttach(data) {
//   return request.post('admin/insurance-attach/delete', data);
// }
export function attachStatus(data) {
  return request.post('admin/v2/insurance-attach/status', data);
}
export function attachDetail(data) {
  return request.post('admin/v2/insurance-attach/detail', data);
}
export function attachList2(data) {
  return request.post('admin/insurance/attach-list', data);
}
// //附加险条款
// export function addAttachTerms(data) {
//   return request.post('admin/insurance-attach/terms-store', data);
// }
// export function editAttachTerms(data) {
//   return request.post('admin/insurance-attach/terms-edit', data);
// }
// export function attachTermsDetail(data) {
//   return request.post('admin/insurance-attach/terms-detail', data);
// }
//附加险方案
export function attachPlanList(data) {
  return request.post('admin/v2/insurance-attach-plan/list', data);
}
export function addAttachPlan(data) {
  if (data.duration.type == 5) {
    data.duration.value = '0';
  }
  if (data.paymentDeadline.way == 0) {
    data.paymentDeadline.type = 0;
    data.paymentDeadline.value = 0;
  }
  data.paymentDeadline = JSON.stringify(data.paymentDeadline);
  data.age = JSON.stringify(data.age);
  data.duration = JSON.stringify(data.duration);
  data.rights = JSON.stringify(data.rights);
  return request.post('admin/v2/insurance-attach-plan/store', data);
}
export function editAttachPlan(data) {
  if (data.duration.type == 5) {
    data.duration.value = '0';
  }
  if (data.paymentDeadline.way == 0) {
    data.paymentDeadline.type = 0;
    data.paymentDeadline.value = 0;
  }
  data.paymentDeadline = JSON.stringify(data.paymentDeadline);
  data.age = JSON.stringify(data.age);
  data.duration = JSON.stringify(data.duration);
  data.rights = JSON.stringify(data.rights);
  return request.post('admin/v2/insurance-attach-plan/edit', data);
}
export function attachPlanDetail(data) {
  return request.post('admin/v2/insurance-attach-plan/detail', data);
}
export function delAttachPlan(data) {
  return request.post('admin/v2/insurance-attach-plan/delete', data);
}
export function attachPlanStatus(data) {
  return request.post('admin/v2/insurance-attach-plan/status', data);
}
//主险
export function mainList(data) {
  // return request.post('admin/insurance/list', data);
  return request.post('admin/v2/insurance/list', data);
}
export function addMainInfo(data) {
  return request.post('admin/insurance/base-info-store', data);
}
export function addMainInfov2(data) {
  return request.post('admin/v2/insurance/base-info-store', data);
}
export function editMainInfo(data) {
  return request.post('admin/v2/insurance/base-info-edit', data);
}
// export function editMainInfo(data) {
//   return request.post('admin/insurance/base-info-edit', data);
// }
export function mainDetail(data) {
  return request.post('admin/insurance/detail', data);
}
export function mainDetailV2(data) {
  return request.post('admin/v2/insurance/detail', data);
}
export function editMainNotice(data) {
  return request.post('admin/insurance/health-notice-edit', data);
}
export function editMainTemplate(data) {
  return request.post('admin/insurance/template-edit', data);
}
export function delMain(data) {
  return request.post('admin/insurance/delete', data);
}
export function mainCopy(data) {
  return request.post('admin/insurance/copy', data);
}
export function mainStatus(data) {
  return request.post('admin/insurance/status', data);
}
export function mainStatusV2(data) {
  return request.post('admin/v2/insurance/status', data);
}
// 健康告知
export function healthEdit(data) {
  return request.post('admin/v2/insurance/health-notice-edit', data);
}
// 条款文件
// 列表
export function termsResource(data) {
  return request.post('admin/v2/insurance-terms/resource', data);
}
// 编辑
export function termsEdit(data) {
  return request.post('admin/v2/insurance-terms/edit', data);
}
// 详情
export function termsDetailV2(data) {
  return request.post('admin/v2/insurance-terms/detail', data);
}
// 删除
export function termsDelete(data) {
  return request.post('admin/v2/insurance-terms/delete', data);
}
// 更新
export function insuranceTermsEdit(data) {
  return request.post('admin/v2/insurance/insurance-terms-edit', data);
}

// 投保提醒

export function insuranceReminder(data) {
  return request.post('admin/agency/insurance-reminder', data);
}

// 投保模板
export function templateStore(data) {
  return request.post('admin/v2/insurance-template/store', data);
}
// 主险方案-附加险资源
export function attachResource(data) {
  return request.post('admin/v2/insurance/attach-resource', data);
}
// 主险-方案列表
export function planList(data) {
  return request.post('admin/v2/insurance-plan/list', data);
}
// 主险-区域资源
export function planArea(data) {
  return request.post('admin/v2/insurance-plan/area', data);
}

// 主险-方案删除
export function planDelete(data) {
  return request.post('admin/v2/insurance-plan/delete', data);
}
// 主险-方案禁用
export function planStatus(data) {
  return request.post('admin/v2/insurance-plan/status', data);
}

// 主险-方案资源
export function planResource(data) {
  return request.post('admin/v2/insurance-plan/resource', data);
}

// 主险-方案对比
export function planContrast(data) {
  return request.post('admin/v2/insurance-plan/contrast', data);
}
// 主险-保费试算资源
export function planMarkResource(data) {
  return request.post('admin/v2/insurance-budget/mark-resource', data);
}

// 主险-保费试算
export function planBudgetConfig(data) {
  return request.post('admin/v2/insurance-budget/budget-config', data);
}
// 主险-获取保费
export function getBudgetpremium(data) {
  return request.post('admin/v2/insurance-budget/premium', data);
}
// 主险-默认方案预览
export function planPreview(data) {
  return request.post('admin/v2/insurance-budget/planPreview', data);
}
// 主险-默认方案预览
export function budgetDetail(data) {
  return request.post('admin/v2/insurance-budget/detail', data);
}

//保险条款 (废弃)
export function termsTemplate(data) {
  return request.post('admin/insurance-terms/template', data);
}
export function termsList(data) {
  return request.post('admin/insurance-terms/list', data);
}
export function addTerms(data) {
  return request.post('admin/insurance-terms/store', data);
}
export function editTerms(data) {
  return request.post('admin/insurance-terms/edit', data);
}
export function delTerms(data) {
  return request.post('admin/insurance-terms/delete', data);
}
export function termsDetail(data) {
  return request.post('admin/insurance-terms/detail', data);
}
export function termsReplace(data) {
  return request.post('admin/insurance-terms/templateReplace', data);
}
export function termsConfig(data) {
  return request.post('admin/insurance/terms-config-edit', data);
}
//主险方案
export function mainPlanList(data) {
  return request.post('admin/insurance-plan/list', data);
}
export function addMainPlan(data) {
  var _data$duration;
  if ((data === null || data === void 0 || (_data$duration = data.duration) === null || _data$duration === void 0 ? void 0 : _data$duration.type) == 5) {
    data.duration.value = '0';
  }
  // return request.post('admin/insurance-plan/store', data);
  return request.post('admin/v2/insurance-plan/store', data);
}
export function editMainPlan(data) {
  if (data.duration.type == 5) {
    data.duration.value = '0';
  }
  // return request.post('admin/insurance-plan/edit', data);
  return request.post('admin/v2/insurance-plan/edit', data);
}
export function mainPlanDetail(data) {
  // return request.post('admin/insurance-plan/detail', data);
  return request.post('admin/v2/insurance-plan/detail', data);
}
export function delPlanDetail(data) {
  return request.post('admin/insurance-plan/delete', data);
}
export function mainPlanStatus(data) {
  return request.post('admin/insurance-plan/status', data);
}
export function mainPlanResource(data) {
  return request.post('admin/insurance-plan/lists', data);
}
export function insuranceResource(data) {
  return request.post('admin/insurance/resource', data);
}
//保费试算
export function addMainBudget(data) {
  return request.post('admin/insurance-budget/store', data);
}
export function editMainBudget(data) {
  return request.post('admin/insurance-budget/edit', data);
}
export function mainBudgetDetail(data) {
  return request.post('admin/insurance-budget/detail', data);
}
export function getTags(data) {
  return request.post('admin/insurance-plan/getTags', data);
}
export function auditFlowInsuranceResource(data) {
  return request.post('admin/audit-flow/insuranceResource', data);
}
export function budgetConfigFilter(data) {
  return request.post('admin/v2/insurance-budget/budget-config/filter', data);
}

//主险方案标签资源数据
export function tagsPlanResource(data) {
  return request.post('admin/insurance-plan/tags/resource', data);
}

//保险条款
export function insuranceTermsResource(data) {
  return request.post('admin/v2/insurance-terms/resource', data);
}
export function insuranceTermsDetail(data) {
  return request.post('admin/v2/insurance-terms/detail', data);
}
export function editInsuranceTerms(data) {
  return request.post('admin/v2/insurance-terms/edit', data);
}
export function addInsuranceTerms(data) {
  return request.post('admin/v2/insurance-terms/store', data);
}
export function getArea(data) {
  return request.post('admin/v2/insurance-plan/area', data);
}